export default __webpack_public_path__ + "static/media/second.b134e01d.png";